export default {
  menu: {
    your_team: 'Ditt lag',
    your_section: {
      _enum: 'SECTION_TERM',
      building: 'Din bygning',
      department: 'Din avdeling',
      discipline: 'Din disiplin',
      faculty: 'Ditt fakultet',
      school: 'Din skole',
      area: 'Ditt område',
      city: 'Din by',
      municipality: 'Din kommune',
      county_municipality: 'Ditt fylke',
      country: 'Ditt land',
      section: 'Din seksjon',
    },
    your_organisation: 'Din organisasjon',
    all_organisations: 'Alle organisasjoner',
  },
  footer: {
    expand: 'Utvid lista',
    hide: 'Sjul fullstending liste',
    page: 'Side %{currentPage} av %{pageCount}',
  },
  lists: {
    team: {
      you: 'Din posisjon',
      active: 'Aktive lagmedlemmer',
      info: 'Bare lagmedlemmer som har logget minst én aktivitet, vises på resultattavlen.',
    },
    section: {
      you: 'Ditt lags posisjon',
      all: {
        _enum: 'SECTION_TERM',
        section: 'Alle lagene i din seksjon',
        building: 'Alle lagene i din bygning',
        department: 'Alle lagene i din avdeling',
        discipline: 'Alle lagene i din disiplin',
        faculty: 'Alle lagene i ditt fakultet',
        school: 'Alle lagene i din skole',
        area: 'Alle lagene i din område',
        city: 'Alle lagene i din by',
        municipality: 'Alle lagene i din kommune',
        county_municipality: 'Alle lagene i ditt fylke',
        country: 'Alle lagene i ditt land',
        other: 'Alle lagene',
      },
    },
    challenge: {
      you: {
        _enum: 'SECTION_TERM',
        section: 'Din seksjons posisjon',
        building: 'Din bygnings posisjon',
        department: 'Din avdelings posisjon',
        discipline: 'Din disiplins posisjon',
        faculty: 'Ditt fakultets posisjon',
        school: 'Din skoles posisjon',
        area: 'Ditt områdes posisjon',
        city: 'Din bys posisjon',
        municipality: 'Din kommunes posisjon',
        county_municipality: 'Ditt fylkes posisjon',
        country: 'Ditt lands posisjon',
        other: 'Din position',
      },
      all: {
        _enum: 'SECTION_TERM',
        section: 'Alle seksjoner i %{organisationName}',
        building: 'Alle bygninger i %{organisationName}',
        department: 'Alle avdelinger i %{organisationName}',
        discipline: 'Alle disipliner i %{organisationName}',
        faculty: 'Alle fakulteter i %{organisationName}',
        school: 'Alle skoler i %{organisationName}',
        area: 'Alle områder i %{organisationName}',
        city: 'Alle byer i %{organisationName}',
        municipality: 'Alle kommuner i %{organisationName}',
        county_municipality: 'Alle fylker i %{organisationName}',
        country: 'Alle land i %{organisationName}',
        other: 'Alle i %{organisationName}',
      },
    },
    championship: {
      you: 'Din organisasjons posisjon',
      all: 'Alle organisasjoner',
      last_updated: 'Sist oppdatert: %{lastUpdated}',
    },
  },
};
